import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getFamilyCartData } from "../../../../Redux/Actions"
import CartIcon from "../../../../Assets/svg/shopping-cart.svg"
import cartStyles from "./Cart.module.css";

const Cart = () => {
  const dispatch = useDispatch();

  const familyCartDetails = useSelector((state) => state.getFamilyCartDataReducer.familyCartData);
  const [cartLength, setCartLength] = useState(0);
  const [login, setLogin] = useState(false);

  useEffect(() => {
    try {
      const userDetails = JSON.parse(localStorage.getItem("user"));
      const token = userDetails && userDetails?.token;
      // var citySelect = "";
      if (token) {
        setLogin(true);
        if (!familyCartDetails?.length)
          dispatch(getFamilyCartData(token));
      }
    } catch {
      //console.log("User Details Not Found")
    }
  }, [dispatch]);

  useEffect(() => {
    // console.log("Family Cart", familyCartDetails);
    let len = 0;
    if (familyCartDetails && Array.isArray(familyCartDetails)) {
      familyCartDetails.forEach((pack) => {
        len += pack?.members.length
      })
    }
    setCartLength(len);
  }, [familyCartDetails]);

  return (
    <div className={cartStyles.header_cartSection}>
      <a
        href={process.env.RAZZLE_APP_BASE_URL + "/cart"}
        style={{ display: "flex", alignItems: "center" }}>
        <div className={cartStyles.cartIconContainer}>
          <img src={CartIcon} className={cartStyles.cartIcon} />
          {login === true && cartLength > 0 ? (
            <span className={cartStyles.cartCount}>{cartLength}</span>
          ) : null}
        </div>
        <span className={cartStyles.cartText}> Cart </span>
      </a>
    </div>
  );
};

export default Cart;
